import { render, staticRenderFns } from "./StarVideo.vue?vue&type=template&id=c16928f4&"
import script from "./StarVideo.vue?vue&type=script&lang=js&"
export * from "./StarVideo.vue?vue&type=script&lang=js&"
import style0 from "./StarVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StarVideo.vue"
export default component.exports